/**
 * Labstep
 *
 * @module report/services/grid-column-definition
 * @desc Helpers for column definitions
 */

import type { ValueSetterParams } from 'ag-grid-community';
import type {
  CellEditorParams,
  CellRendererParams,
} from 'labstep-web/core/DataGrid/types';
import { stopEditingAndFocus } from 'labstep-web/core/DataGrid/utils';
import type { APICallOptions } from 'labstep-web/models';
import type { Entity } from 'labstep-web/models/entity.model';

export class GridColumnDefinitionService {
  public static refreshCell = (
    params:
      | ValueSetterParams
      | CellRendererParams<Entity>
      | CellEditorParams<Entity>,
  ): void => {
    if (!params.node) {
      return;
    }
    params.api.refreshCells({
      rowNodes: [params.node],
      columns: [params.column],
      force: true,
    });
  };

  public static getOptions = (
    params:
      | ValueSetterParams
      | CellRendererParams<Entity>
      | CellEditorParams<Entity>,
    onSuccess?: () => void,
  ): APICallOptions => {
    return {
      onSuccess: (): void => {
        this.refreshCell(params);
        stopEditingAndFocus(params);
        if (onSuccess) {
          onSuccess();
        }
      },
    };
  };
}
